module.exports = __webpack_public_path__ + "static/media/g4.005a79ed.jpg";